var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-msg" },
    [
      _c(
        "el-form-item",
        {
          staticClass: "el-checkbox",
          attrs: {
            label: _vm.$t.__("pages.account.sale.CustomMessage.custom_message")
          }
        },
        [
          _c(
            "el-checkbox",
            {
              staticClass: "mt-2 flex-row",
              attrs: { label: _vm.messageUsed },
              model: {
                value: _vm.messageUsed,
                callback: function($$v) {
                  _vm.messageUsed = $$v
                },
                expression: "messageUsed"
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Joindre mon message personnalisé dans l’email envoyé"
                    )
                  ) +
                  "\n        "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.messageUsed,
              expression: "messageUsed"
            }
          ]
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "customMessage" } },
            [
              _c("RichText", {
                staticClass: "custom-richtext",
                attrs: {
                  placeholder: _vm.$t.__("common.actions.enter_custom_message"),
                  options: _vm.optionsRichText
                },
                model: {
                  value: _vm.message,
                  callback: function($$v) {
                    _vm.message = $$v
                  },
                  expression: "message"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "fs-2 gray-60 mt-3" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Votre nom et email seront automatiquement ajoutés après votre message personnalisé."
                  )
                ) +
                "\n        "
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }